'use client';

import * as React from 'react';
import Image from 'next/image';

import { APP_NAME } from '@workspace/common/app';
import { useMounted } from '@workspace/ui/hooks/use-mounted';
import { useTheme } from '@workspace/ui/hooks/use-theme';
import { cn } from '@workspace/ui/lib/utils';

import LogoIcon from '../public/logo-icon.svg';
import LogoBlack from '../public/logo-text-black.svg';
import LogoWhite from '../public/logo-text-white.svg';

export type LogoElement = React.ComponentRef<'div'>;
export type LogoProps = React.ComponentPropsWithoutRef<'div'> & {
  hideSymbol?: boolean;
  hideWordmark?: boolean;
};
export function Logo({
  hideSymbol,
  hideWordmark,
  className,
  ...other
}: LogoProps): React.JSX.Element {
  const { resolvedTheme } = useTheme();
  const mounted = useMounted();

  // Use black logo for light theme, white logo for dark theme
  // Default to black logo during SSR to prevent hydration mismatch
  const logoSrc = mounted && resolvedTheme === 'dark' ? LogoWhite : LogoBlack;

  return (
    <div
      className={cn('flex items-center space-x-2', className)}
      {...other}
    >
      {!hideSymbol && (
        <div className="flex items-center justify-center">
          <Image
            src={LogoIcon}
            alt={`${APP_NAME} logo`}
            className="h-8 w-auto"
            priority
          />
        </div>
      )}
      {!hideWordmark && (
        <div className="flex items-center justify-center">
          <Image
            src={logoSrc}
            alt={`${APP_NAME} logo`}
            className="h-8 w-auto"
            priority
          />
        </div>
      )}
      {/* {!hideWordmark && <span className="font-bold">{APP_NAME}</span>} */}
    </div>
  );
}
